const gapMobile = parseInt(document.querySelector('.bc-content').getAttribute('data-gap-mobile')) || 20;
const gapDesktop = parseInt(document.querySelector('.bc-content').getAttribute('data-gap-desktop')) || 20;

function checkScrollOverflow() {
    const bcRows = document.querySelectorAll('.brand-carousel .bc-row');
    
    bcRows.forEach(row => {
        const items = row.querySelectorAll('.bc-item');
        const rowWidth = row.clientWidth;
        
        let totalContentWidth = 0;
        let currentGap = window.innerWidth >= 750 ? gapDesktop : gapMobile;
        
        items.forEach((item, index) => {
            const itemWidth = item.offsetWidth;
            totalContentWidth += itemWidth;
            
            if (index < items.length - 1) {
                totalContentWidth += currentGap;
            }
        });
        
        if (totalContentWidth > rowWidth) {
            row.classList.add('has-scroll');
        } else {
            row.classList.remove('has-scroll');
        }
    });
}

window.addEventListener('load', checkScrollOverflow);
window.addEventListener('resize', checkScrollOverflow);

var swiper = new Swiper('.bc-swiper', {
    slidesPerView: 'auto',
    spaceBetween: gapMobile,
    slidesPerGroup: 1,
    grabCursor: true,
    keyboard: {
        enabled: true,
    },
    breakpoints: {
        750: {
            spaceBetween: gapDesktop,
            slidesPerGroup: 1,
        }
    },
    on: {
        init: function() {
            setTimeout(checkScrollOverflow, 100);
        },
        resize: function() {
            setTimeout(checkScrollOverflow, 100);
        }
    }
});